var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20077 14.5C4.35077 14.5 4.55077 14.45 4.70077 14.4L10.2508 12.45C10.8508 12.25 11.1508 11.6 10.9508 11C10.7508 10.4 10.1008 10.1 9.50077 10.3L6.05077 11.5C7.70077 7.19999 11.9008 4.29999 16.7008 4.29999C21.9508 4.29999 26.5008 7.79999 27.8008 12.8C27.9508 13.4 28.5508 13.75 29.1508 13.6C29.7508 13.45 30.1008 12.85 29.9508 12.25C28.4008 6.24999 22.9508 2.04999 16.6508 2.04999C11.0508 2.04999 6.10077 5.34999 4.05077 10.3L3.00077 7.29999C2.80077 6.69999 2.15077 6.39999 1.55077 6.59999C0.950767 6.79999 0.650767 7.44999 0.850767 8.04999L2.75077 13.5C3.05077 14.15 3.60077 14.5 4.20077 14.5Z",
    fill: "url(#paint0_linear_39_11172)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0504 24.85L29.0004 19.5C28.8504 19.15 28.6004 18.85 28.2504 18.7C27.9004 18.55 27.5004 18.55 27.1504 18.7L21.6504 20.8C21.0504 21 20.8004 21.65 21.0004 22.25C21.2004 22.85 21.8504 23.1 22.4504 22.9L25.9004 21.6C23.9004 25.25 20.0004 27.65 15.6504 27.65C10.7004 27.65 6.35038 24.55 4.80038 19.95C4.60038 19.35 3.95038 19.05 3.40038 19.25C2.80038 19.45 2.50038 20.1 2.70038 20.65C4.55038 26.15 9.75038 29.85 15.6504 29.85C20.8004 29.85 25.4504 27 27.8004 22.6L28.9504 25.65C29.1004 26.1 29.5504 26.35 30.0004 26.35C30.1504 26.35 30.2504 26.35 30.4004 26.25C31.0004 26.1 31.2504 25.45 31.0504 24.85Z",
    fill: "url(#paint1_linear_39_11172)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_11172",
    x1: 15.3872,
    y1: 2.04999,
    x2: 15.3872,
    y2: 17.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_11172",
    x1: 16.8784,
    y1: 18.5875,
    x2: 16.8784,
    y2: 32.2328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon-02.902034a9ef7af570dfc7b3d91ab943e8.svg";
export { ForwardRef as ReactComponent };